module.exports = __webpack_public_path__ + "img/shining_gold.d2b6db8b.png";